module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    staticClass: "container",
    attrs: {
      "id": "category"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 22,
      "offset": 1
    }
  }, [_c('div', {
    staticClass: "category-legend",
    domProps: {
      "textContent": _vm._s(_vm.content.name)
    }
  }), _vm._v(" "), (_vm.orphan) ? _c('div', {
    staticClass: "border left"
  }) : _vm._e(), _vm._v(" "), (_vm.orphan) ? _c('div', {
    staticClass: "border right"
  }) : _vm._e(), _vm._v(" "), (_vm.content.children) ? [_c('el-tabs', {
    attrs: {
      "type": "card"
    },
    on: {
      "tab-click": _vm.handleClick
    }
  }, [_c('div', {
    staticClass: "tabs-container"
  }, [_vm._l((_vm.content.children), function(category) {
    return [_c('el-tab-pane', {
      attrs: {
        "label": category.name
      }
    }, [(category.children) ? [_vm._l((category.children), function(subcategory) {
      return [_c('el-row', [_c('div', {
        staticClass: "legend",
        domProps: {
          "textContent": _vm._s(subcategory.name)
        }
      }), _vm._v(" "), _vm._l((subcategory.products), function(product) {
        return [_c('el-col', {
          staticClass: "product",
          attrs: {
            "span": 8
          }
        }, [_c('div', {
          staticClass: "inner"
        }, [_c('div', {
          domProps: {
            "textContent": _vm._s(product.title)
          }
        }), _vm._v(" "), _c('router-link', {
          staticClass: "link",
          attrs: {
            "to": {
              name: 'subcategory',
              params: {
                category: _vm.slug,
                subcategory: category.slug,
                subsubcategory: subcategory.slug,
                product: product.slug
              }
            }
          }
        })], 1)])]
      })], 2)]
    })] : [_vm._l((category.products), function(product) {
      return [_c('el-col', {
        staticClass: "product",
        attrs: {
          "span": 8
        }
      }, [_c('div', {
        staticClass: "inner"
      }, [_c('div', {
        domProps: {
          "textContent": _vm._s(product.title)
        }
      }), _vm._v(" "), _c('router-link', {
        staticClass: "link",
        attrs: {
          "to": {
            name: 'subcategory',
            params: {
              category: _vm.slug,
              subcategory: category.slug,
              product: product.slug
            }
          }
        }
      })], 1)])]
    })]], 2)]
  })], 2)])] : [_c('div', [_vm._l((_vm.content.products), function(product) {
    return [_c('el-col', {
      staticClass: "product",
      attrs: {
        "span": 8
      }
    }, [_c('div', {
      staticClass: "inner"
    }, [_c('div', {
      domProps: {
        "textContent": _vm._s(product.title)
      }
    }), _vm._v(" "), _c('router-link', {
      staticClass: "link",
      attrs: {
        "to": {
          name: 'product',
          params: {
            category: _vm.slug,
            product: product.slug
          }
        }
      }
    })], 1)])]
  })], 2)]], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-235c0c7a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Category.vue
// module id = 138
// module chunks = 1